module.exports = __webpack_public_path__ + "static/img/introduce_bg.5b4d925a.png";